import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  IconButton
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const EnterNpiStep = ({
  npi,
  error,
  loading,
  onChange,
  onSubmit,
  onOpenClearDialog
}) => (
    <Box sx={{ maxWidth: 400 }}>
      <Typography variant="h6" gutterBottom>
        Enter Your NPI Number
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Please enter your personal NPI number (NPI-1). This will be used to verify your provider identity.
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
        <TextField
          fullWidth
          label="NPI Number"
          value={npi}
          onChange={onChange}
          error={!!error}
          helperText={error}
        />
        {npi && (
        <IconButton onClick={onOpenClearDialog} sx={{ mt: 1 }}>
            <ClearIcon />
        </IconButton>
      )}
      </Box>
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={loading}
        sx={{ mt: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : 'Validate NPI'}
      </Button>
  </Box>
);

export default EnterNpiStep;